<div class="card">
    <i></i>
    <!-- <img src="../../../../assets/nosotros/1HUGO_SAVARECIO.png" alt="" class="card-photo"> -->
</div>